import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DURATION_OPTIONS, type DurationMonths } from '../features/subscription/subscriptionUtils'
import { CheckoutSuccessPage } from '../features/checkout/CheckoutSuccessPage'

const checkoutSuccessSearchSchema = z.object({
  plan: z
    .string()
    .optional()
    .transform((value) => (value ? value : undefined))
    .catch(undefined),
  term: z.coerce
    .number()
    .optional()
    .transform((value) =>
      value !== undefined && (DURATION_OPTIONS as readonly number[]).includes(value)
        ? (value as DurationMonths)
        : undefined,
    )
    .catch(undefined),
  method: z
    .enum(['card', 'hnt', 'credit'])
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute('/_auth/checkout_/success')({
  validateSearch: checkoutSuccessSearchSchema,
  component: CheckoutSuccessRoute,
})

function CheckoutSuccessRoute() {
  const search = Route.useSearch()

  return <CheckoutSuccessPage planId={search.plan} term={search.term} method={search.method} />
}
